import React, { useEffect, useState } from "react";
import { LineInput } from "components/Inputs/LineInput";

import LabeledToggle from "components/Inputs/Toggle/Toggle";

import * as adminReducer from "containers/Admin/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import AWSModelIcon from "images/Model Icons/aws.svg";
import GoogleModelIcon from "images/logo-gcp.svg";
import LlamaModelIcon from "images/Model Icons/llama.svg";
import MistralModelIcon from "images/Model Icons/mistral-logo.svg";
import OpenAIModelIcon from "images/Model Icons/openai 1.svg";

import { useDispatch, useSelector } from "types/store";

import { Button } from "aible";

import ProvisionedLLMButtonTile from "components/LLM/ProvisionedLLMButtonTile";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const LlmManagementView = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(adminReducer.fetchAccounts());
  }, []);

  const [showLLMSettingsModal, updateShowLLMSettingsModal] = useState(false);
  const [selectedLLM, updateSelectedLLM] = useState(undefined);
  const [createNew, updateCreateNew] = useState(undefined);

  const isLoadingAccounts = useSelector((state) => adminReducer.getIsLoadingAccounts(state));

  const LLM_PROVISION_OPTIONS = [
    {
      id: "Google PaLM 2",
      name: "Google PaLM 2",
      enabled: true
    },
    {
      id: "Google Gemini",
      name: "Google Gemini",
      enabled: true
    },
    {
      id: "OpenAI GPT-4",
      name: "OpenAI GPT-4",
      enabled: true
    },
    {
      id: "OpenAI GPT-3.5",
      name: "OpenAI GPT-3.5",
      enabled: true
    },
    {
      id: "Mistral AI",
      name: "Mistral AI"
    },
    {
      id: "Meta Llama 2",
      name: "Meta Llama 2"
    },
    {
      id: "Amazon Titan",
      name: "Amazon Titan",
      enabled: true
    }
  ];

  const PROVISIONED_OPTIONS = [
    {
      id: "Google PaLM 2",
      name: "Google PaLM 2",
      enabled: true,
      temp1: "details",
      temp2: "details",
      description: "Some description that the user adds for this model. It could be useful for Mistral uses",
      created_by: { id: 0, fullname: "test" },
      created_date: "2024-01-08T09:54:05.733Z",
      metadata: {
        status: "COMPLETE"
      }
    },
    {
      id: "Mistral AI",
      name: "Mistral AI",
      enabled: false,
      temp1: "details2",
      temp2: "details2",
      description: "Some description that the user adds for this model. It could be useful for Mistral uses",
      created_by: { id: 0, fullname: "test" },
      created_date: "2024-01-08T09:54:05.733Z",
      metadata: {
        status: "COMPLETE"
      }
    },
    {
      id: "OpenAI GPT-4",
      name: "OpenAI GPT-4",
      enabled: true,
      temp1: "details3",
      temp2: "details3",
      description: "Some description that the user adds for this model. It could be useful for Mistral uses",
      created_by: { id: 0, fullname: "test" },
      created_date: "2024-01-08T09:54:05.733Z",
      metadata: {
        status: "COMPLETE"
      }
    },
    {
      id: "Meta Llama 2",
      name: "Meta Llama 2",
      temp1: "details3",
      temp2: "details3",
      description: "Some description that the user adds for this model. It could be useful for Mistral uses",
      created_by: { id: 0, fullname: "test" },
      created_date: "2024-01-08T09:54:05.733Z",
      metadata: {
        status: "COMPLETE"
      }
    },
    {
      id: "Amazon Titan",
      name: "Amazon Titan",
      enabled: true,
      temp1: "details3",
      temp2: "details3",
      description: "Some description that the user adds for this model. It could be useful for Mistral uses",
      created_by: { id: 0, fullname: "test" },
      created_date: "2024-01-08T09:54:05.733Z",
      metadata: {
        status: "COMPLETE"
      }
    }
  ];

  const handleProvisionedClick = (llm) => {
    updateCreateNew(false);
    updateSelectedLLM(llm);
    updateShowLLMSettingsModal(true);
  };

  const getLogoIcon = (llmType) => {
    if (llmType === "Google PaLM 2" || llmType === "Google Gemini") {
      return GoogleModelIcon;
    }
    if (llmType === "OpenAI GPT-4" || llmType === "OpenAI GPT-3.5") {
      return OpenAIModelIcon;
    }
    if (llmType === "Mistral AI") {
      return MistralModelIcon;
    }
    if (llmType === "Meta Llama 2") {
      return LlamaModelIcon;
    }
    if (llmType === "Amazon Titan") {
      return AWSModelIcon;
    }
    return undefined;
  };

  return (
    <React.Fragment>
      <div className={styles.llmManagementPanel}>
        {isLoadingAccounts ? (
          <LoadingIndicator
            style={{
              width: "20px",
              height: "18px",
              transform: "scale(0.40)",
              margin: "10px 0px 3px 0px"
            }}
          />
        ) : (
          <React.Fragment>
            <div className={styles.llmManagementHeader}>
              <div className={styles.llmManagementTitle}>{`What LLM Would You Like To Add?`}</div>
              <div className={styles.llmManagementActions}>
                {LLM_PROVISION_OPTIONS.map((llm, index) => {
                  return (
                    <AddLLMButtonTile
                      updateShowModal={updateShowLLMSettingsModal}
                      selectLLM={updateSelectedLLM}
                      llm={llm}
                      createNew
                      updateCreateNew={updateCreateNew}
                      key={llm?.base_model_id + "_" + index}
                      getLogo={getLogoIcon}
                    />
                  );
                })}
              </div>
            </div>
            <div className={styles.llmProvisionedSection}>
              <div className={styles.llmManagementTitle}>{`My LLMs`}</div>
              <div className={styles.llmProvisionedContainer}>
                {PROVISIONED_OPTIONS.map((llm, index) => {
                  return (
                    <ProvisionedLLMButtonTile
                      llm={llm}
                      key={llm?.name + "_" + index}
                      getLogo={getLogoIcon}
                      handleClick={handleProvisionedClick}
                      provisioning
                    />
                  );
                })}
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
      <LLMSettingsModal
        showModal={showLLMSettingsModal}
        updateShowModal={updateShowLLMSettingsModal}
        llm={selectedLLM}
        createNew={createNew}
        getLogo={getLogoIcon}
      />
    </React.Fragment>
  );
};

const AddLLMButtonTile = ({ updateShowModal, selectLLM, llm, createNew, updateCreateNew, getLogo } = {}) => {
  const handleClick = () => {
    selectLLM(llm);
    if (createNew) {
      updateCreateNew(true);
    } else {
      updateCreateNew(false);
    }
    updateShowModal(true);
  };

  return (
    <Button onClick={() => handleClick()} className={styles.addLlmButtonTile} disabled={createNew && !llm?.enabled}>
      <div className={styles.addLlmIconWrapper}>
        <img src={getLogo(llm?.id)} className={styles.addLlmLogo} />
      </div>
      {llm?.name}
    </Button>
  );
};

const LLMSettingsModal = ({ showModal, updateShowModal, llm, createNew, getLogo } = {}) => {
  const initialState = {
    name: llm?.name,
    temp1: llm?.temp1,
    temp2: llm?.temp2,
    description: llm?.description,
    enabled: llm?.enabled ?? false
  };

  const [name, updateName] = useState(undefined);
  const [temp1, updateTemp1] = useState(undefined);
  const [temp2, updateTemp2] = useState(undefined);
  const [description, updateDescription] = useState(undefined);
  const [enabled, updateEnabled] = useState(undefined);

  const resetFields = () => {
    updateName(initialState?.name);
    updateTemp1(initialState?.temp1);
    updateTemp2(initialState?.temp2);
    updateDescription(initialState?.description);
    updateEnabled(initialState?.enabled);
  };

  useEffect(() => {
    resetFields();
  }, [llm]);

  return (
    <Dialog
      open={showModal}
      onOpenChange={() => {
        updateShowModal(false);
        resetFields();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <img src={getLogo(llm?.id)} className={styles.modalLlmLogo} />
            {createNew ? `Add a ${llm.type} LLM` : `Edit ${llm?.name}`}
          </DialogTitle>
        </DialogHeader>
        <div className={styles.llmModalBody}>
          <div className={styles.llmModalStandardOptions}>
            <div className={styles.llmSettingItem}>
              <div className={styles.llmItemLabel}>{"Name: "}</div>
              <div className={styles.llmItemField}>
                <LineInput value={name} updateInstant onChange={(val) => updateName(val)} />
              </div>
            </div>
            <div className={styles.llmSettingItem}>
              <div className={styles.llmItemLabel}>{"Field 2: "}</div>
              <div className={styles.llmItemField}>
                <LineInput value={temp1} updateInstant onChange={(val) => updateTemp1(val)} />
              </div>
            </div>
            <div className={styles.llmSettingItem}>
              <div className={styles.llmItemLabel}>{"Field 3: "}</div>
              <div className={styles.llmItemField}>
                <LineInput value={temp2} updateInstant onChange={(val) => updateTemp2(val)} />
              </div>
            </div>
            <div className={styles.llmSettingItem}>
              <div className={styles.llmItemLabel}>{"Description: "}</div>
              <div className={styles.llmItemField}>
                <textarea
                  className={styles.llmDescriptionInput}
                  value={description}
                  onChange={(val) => updateDescription(val.target.value)}
                />
              </div>
            </div>
          </div>
          {!createNew && (
            <div className={styles.llmEditOptions}>
              <div className={styles.llmEditItem} style={{ margin: "24px 0px" }}>
                <div className={styles.toggleWrapper}>
                  <LabeledToggle
                    style={{ display: "block", marginRight: "8px" }}
                    checked={enabled}
                    onChange={() => {
                      updateEnabled(!enabled);
                    }}
                    isAibleColors
                  />
                  {"Enabled"}
                </div>
              </div>
              <div className={styles.llmEditItem} style={{ margin: "24px 0px" }}>
                <div className={styles.deleteWarningtext}>
                  {"Would you like to remove this LLM from your organization? This action cannot be undone."}
                </div>
                <Button
                  onClick={() => {
                    console.log("Delete LLM was pressed");
                  }}
                  style={{ color: "red", borderColor: "red" }}
                  isSmall
                >
                  {"Delete LLM"}
                </Button>
              </div>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button
            onClick={() => {
              updateShowModal(false);
              resetFields();
            }}
          >
            {"Close"}
          </Button>
          <Button
            onClick={() => {
              updateShowModal(false);
              console.log("Add LLM was pressed");
            }}
            type="primary"
          >
            {createNew ? "Add LLM" : "Apply Updates"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LlmManagementView;
